export default [
    {
        id: 'activeFeedback',
        name: 'Active Feedback',
    },
    {
        id: 'appFeatures',
        name: 'App Features',
    },
    {
        id: 'appOperation',
        name: 'App Operation',
    },
    {
        id: 'app-update',
        name: 'App Update',
    },
    {
        id: 'custom',
        name: 'Custom',
    },
    {
        id: 'demoExclusionsLanguage',
        name: 'Demo Enable Language',
    },
    {
        id: 'draw',
        name: 'Draw',
    },
    {
        id: 'feedback',
        name: 'Feedback',
    },
    {
        id: 'InventoryBarcodeScanning',
        name: 'Inventory Barcode Scanning',
    },
    {
        id: 'jsonMatrix',
        name: 'JSON Matrix',
    },
    {
        id: 'shopping',
        name: 'Shopping',
    },
    {
        id: 'SmartInventoryBarcodeScanning',
        name: 'SmartInventory Barcode Scanning',
    },
    {
        id: 'url',
        name: 'URL',
    },
    {
        id: 'warranty',
        name: 'Warranty',
    },
    {
        id: 'whatsapp-support',
        name: 'Whatsapp Support',
    },
    {
        id: 'wpExpirationDate',
        name: 'wpExpirationDate',
    },
];
